module.exports = __webpack_public_path__ + "img/video-player/joy@2x-4b58d890de477a646fa87c853395729b.png";